export const MIN_ALLOWED_DATE_STRING = '1900-01-01';
